import React, { useState } from 'react';

const ContactForm: React.FC = () => {
  // 控制当前放大的二维码（微信 or 小红书）
  const [zoomImage, setZoomImage] = useState<{
    src: string;
    alt: string;
    label?: string;
  } | null>(null);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              获取<strong>专业咨询</strong>
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              我们的专家团队将为您提供<strong>个性化的科研服务解决方案</strong>，助力您的科研和业务发展
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* 联系信息 */}
          <div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">公司地址</h3>
                  <a
                    href="https://map.baidu.com/search/北京市海淀区知春路9号10层101/@12958285.09,4825290.97,19z?querytype=s&da_src=shareurl&wd=北京市海淀区知春路9号10层101&c=131&src=0&pn=0&sug=0&l=12&b=(12958285.09,4825290.97;12958285.09,4825290.97)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-blue-600 transition-colors duration-200 cursor-pointer"
                  >
                    北京市海淀区知春路9号10层101
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg flex-shrink-0">
                  <i className="ri-phone-line text-xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">联系电话</h3>
                  <p className="text-gray-600">17601000721</p>
                  <p className="text-gray-600">工作时间：周一至周五 9:00-18:00</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-lg flex-shrink-0">
                  <i className="ri-mail-line text-xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">邮箱地址</h3>
                  <p className="text-gray-600">wang_bioresearch@163.com</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">响应时间</h3>
                  <p className="text-gray-600">24小时内回复</p>
                  <p className="text-gray-600">紧急项目可提供加急服务</p>
                </div>
              </div>
            </div>

            {/* 微信和小红书二维码区域 */}
{/* 联系方式二维码区域 */}
<div className="mt-10">
  <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-6 gap-2">
    <div>
      <h3 className="text-lg font-semibold text-gray-900">添加/关注我们</h3>
      <p className="text-sm text-gray-500">
        扫码添加微信、关注小红书与公众号，获取专业咨询与案例分享
      </p>
    </div>
  </div>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
    {/* 微信二维码 */}
    <div className="bg-white rounded-2xl p-6 shadow-sm border flex flex-col h-full">
      <div className="flex items-center mb-4">
        <div className="w-11 h-11 flex items-center justify-center bg-green-50 rounded-xl mr-3">
          <i className="ri-wechat-fill text-2xl text-green-600"></i>
        </div>
        <div>
          <h4 className="font-semibold text-gray-900 text-base">微信咨询</h4>
          <p className="text-xs text-gray-500">一对一沟通，快速响应</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center">
        <button
          type="button"
          onClick={() =>
            setZoomImage({
              src: 'https://static.readdy.ai/image/6618cd6b01c2b328e76d4c92fdf9df11/64f840350b1201206dc23007b3df5948.png',
              alt: '微信二维码',
              label: '微信二维码',
            })
          }
          className="bg-gray-50 p-4 rounded-xl transition-transform duration-300 hover:scale-105 cursor-pointer focus:outline-none"
        >
          <img
            src="https://static.readdy.ai/image/6618cd6b01c2b328e76d4c92fdf9df11/64f840350b1201206dc23007b3df5948.png"
            alt="微信二维码"
            className="w-36 h-36 object-contain mx-auto"
          />
        </button>
      </div>

      <div className="mt-4 text-center">
        <p className="text-sm text-gray-700 font-medium">BioInfo-王老师</p>
        <p className="text-xs text-gray-400 mt-1">点击二维码可放大查看</p>
      </div>
    </div>

    {/* 小红书二维码 */}
    <div className="bg-white rounded-2xl p-6 shadow-sm border flex flex-col h-full">
      <div className="flex items-center mb-4">
        <div className="w-11 h-11 flex items-center justify-center bg-red-50 rounded-xl mr-3">
          <img
            src="https://static.readdy.ai/image/6618cd6b01c2b328e76d4c92fdf9df11/73232460550aa645848bb423e03f0202.png"
            alt="小红书图标"
            className="w-7 h-7 object-contain"
          />
        </div>
        <div>
          <h4 className="font-semibold text-gray-900 text-base">小红书主页</h4>
          <p className="text-xs text-gray-500">案例拆解 & 干货分享</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center">
        <button
          type="button"
          onClick={() =>
            setZoomImage({
              src: 'https://static.readdy.ai/image/6618cd6b01c2b328e76d4c92fdf9df11/34edc64587d9ebc1c238eb3c75d532ef.png',
              alt: '小红书二维码',
              label: '小红书二维码',
            })
          }
          className="bg-gray-50 p-4 rounded-xl transition-transform duration-300 hover:scale-105 cursor-pointer focus:outline-none"
        >
          <img
            src="https://static.readdy.ai/image/6618cd6b01c2b328e76d4c92fdf9df11/34edc64587d9ebc1c238eb3c75d532ef.png"
            alt="小红书二维码"
            className="w-36 h-36 object-contain mx-auto"
          />
        </button>
      </div>

      <div className="mt-4 text-center">
        <p className="text-sm text-gray-700 font-medium">AIBioinfo</p>
        <p className="text-xs text-gray-400 mt-1">点击二维码可放大查看</p>
      </div>
    </div>

    {/* 公众号二维码 */}
    <div className="bg-white rounded-2xl p-6 shadow-sm border flex flex-col h-full">
      <div className="flex items-center mb-4">
        <div className="w-11 h-11 flex items-center justify-center bg-emerald-50 rounded-xl mr-3">
          <i className="ri-article-line text-2xl text-emerald-600"></i>
        </div>
        <div>
          <h4 className="font-semibold text-gray-900 text-base">微信公众号</h4>
          <p className="text-xs text-gray-500">长文解析 & 系统教程</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center">
        <button
          type="button"
          onClick={() =>
            setZoomImage({
              src: '/images/contact/wechat_public.jpg', // 👉 这里换成你自己的公众号二维码链接
              alt: '微信公众号二维码',
              label: '微信公众号二维码',
            })
          }
          className="bg-gray-50 p-4 rounded-xl transition-transform duration-300 hover:scale-105 cursor-pointer focus:outline-none"
        >
          <img
            src="/images/contact/wechat_public.jpg" // 👉 同上，替换成真实地址
            alt="微信公众号二维码"
            className="w-36 h-36 object-contain mx-auto"
          />
        </button>
      </div>

      <div className="mt-4 text-center">
        <p className="text-sm text-gray-700 font-medium">BioInfo | 生信笔记</p>
        <p className="text-xs text-gray-400 mt-1">点击二维码可放大查看</p>
      </div>
    </div>
  </div>
</div>

          </div>
        </div>

        {/* 放大二维码弹窗 */}
        {zoomImage && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
            onClick={() => setZoomImage(null)} // 点击遮罩关闭
          >
            <div
              className="bg-white rounded-xl p-4 max-w-[90vw] max-h-[90vh] flex flex-col items-center"
              onClick={(e) => e.stopPropagation()} // 阻止冒泡，避免点图片也关闭
            >
              <img
                src={zoomImage.src}
                alt={zoomImage.alt}
                className="max-w-[80vw] max-h-[70vh] object-contain"
              />
              {zoomImage.label && (
                <p className="mt-3 text-sm text-gray-600">
                  {zoomImage.label}
                </p>
              )}
              <button
                type="button"
                onClick={() => setZoomImage(null)}
                className="mt-4 px-5 py-2 rounded-full text-sm bg-gray-900 text-white hover:bg-gray-800"
              >
                关闭
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ContactForm;
